export default __webpack_public_path__ + "02f1215f99df0a7a03ac1d5986ace874.png";